module.exports = __webpack_public_path__ + "static/media/19ESCAP51.e0e7c402.jpg";